define.alias("shared/components/shared/date-time-picker", "settings/components/shared/date-time-picker");